export const getFaceCensorshipWarningCopy = (warning: string) => {
  if (warning === "no_face_detected") {
    return "No face was detected. Add a blur region manually or switch to Sticker mode.";
  }
  if (warning === "face_bbox_fallback_used") {
    return "One or more faces use a bounding-box fallback. Review each proposed region and resize it if needed.";
  }
  return "Face detection returned a warning. Review every region before export.";
};

export const canRecoverWithManualFaceCensorship = ({
  metadataSuccess,
  isFaceCensorshipSelected,
  isCoverFilterSelected,
}: {
  metadataSuccess: boolean;
  isFaceCensorshipSelected: boolean;
  isCoverFilterSelected: boolean;
}) => !metadataSuccess && isFaceCensorshipSelected && !isCoverFilterSelected;

export const getFaceDetectionResultSlots = ({
  downloadUrls,
  imageCount,
  isFaceDetectionJob,
}: {
  downloadUrls: string[];
  imageCount: number;
  isFaceDetectionJob: boolean;
}): string[] | null => {
  if (downloadUrls.length === imageCount) return downloadUrls;
  if (isFaceDetectionJob && downloadUrls.length === 0) {
    return Array.from({ length: imageCount }, () => "");
  }
  return null;
};
